"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("../Services/service.service");
var WickedApiClient_1 = require("../api/WickedApiClient");
var geolocation_service_1 = require("../Services/geolocation.service");
var rxjs_1 = require("rxjs");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var router_1 = require("@angular/router");
var player_1 = require("@vimeo/player");
var searchroute_service_1 = require("../Services/searchroute.service");
var HomeComponent = /** @class */ (function () {
    function HomeComponent(service, geolocationService, cookieService, route, activeRoute, searchRouteService) {
        var _this = this;
        this.service = service;
        this.geolocationService = geolocationService;
        this.cookieService = cookieService;
        this.route = route;
        this.activeRoute = activeRoute;
        this.searchRouteService = searchRouteService;
        this.category = "women-seeking-men";
        this.type = "long-term";
        this.withPicture = "";
        this.city = "il-chicago";
        this.isPremium = false;
        this._muteBanner = true;
        this.route.events.subscribe(function (val) {
            console.log(val);
        });
        this.isPremium = this.service.userService.isPremium();
        if (this.constructor != HomeComponent)
            this.mostPopularCities = this.geolocationService.CitiesByPopulation(60, true);
        else
            this.mostPopularCities = this.geolocationService.CitiesByPopulation(60);
        this.service.advService.getCategories(false).then(function (categories) {
            _this.categories = categories;
        });
        if (this.cookieService.check("hiddenVideo")) {
            this.showWickedVideo = false;
        }
        this.route.onSameUrlNavigation = "ignore";
    }
    Object.defineProperty(HomeComponent.prototype, "showWickedVideo", {
        get: function () {
            return this.service.showStartVideo;
        },
        set: function (val) {
            this.service.showStartVideo = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeComponent.prototype, "muteBanner", {
        get: function () {
            return this._muteBanner;
        },
        set: function (value) {
            this._muteBanner = value;
        },
        enumerable: true,
        configurable: true
    });
    HomeComponent.prototype.ngOnDestroy = function () {
        if (this.currentSearchRuleChangedSubsctiption) {
            this.currentSearchRuleChangedSubsctiption.unsubscribe();
        }
    };
    HomeComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.showWickedVideo) {
            var player = new player_1.default(this.wickedVideo.nativeElement, { id: 373344002, byline: false, portrait: false, title: false, autoplay: true, width: this.wickedVideo.nativeElement.offsetWidth, height: this.wickedVideo.nativeElement.offsetHeight });
            player.ready().catch(function (e) {
                _this.showWickedVideo = false;
            });
            player.on("play", function () {
                _this.cookieService.set("hiddenVideo", "true");
            });
            player.on("ended", function () {
                _this.showWickedVideo = false;
            });
            player.on("error", function () {
                _this.showWickedVideo = false;
            });
        }
        //if (this.activeRoute.snapshot.params && this.activeRoute.snapshot.params.cityId) {
        //  let city = this.mostPopularCities.find(x => x.subRegionId == this.activeRoute.snapshot.params.cityId);
        //  if (city) {
        //    this.changeSubRegion(city);
        //  }
        //}
        this.service.hideLoader();
    };
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.queryParamMap.subscribe(function (params) {
            var action = params.get("action");
            var param = params.get("param");
            if (action === "new-password") {
                if (param && param.length > 0) {
                    _this.route.navigate(["/new-password", param]);
                }
            }
            else if (action === "validate-email") {
                if (param && param.length > 0) {
                    _this.route.navigate(["/validate-email", param]);
                }
            }
            //validate-email/d501e597-e1da-4622-a2a2-dda1d089ec79
        });
        this.currentSearchRuleChangedSubsctiption = this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(function (rule) {
            if (rule.advertisementCategoryId) {
                var category = _this.categories.find(function (c) { return c.advertisementCategoryId == rule.advertisementCategoryId; });
                if (category) {
                    _this.category = category.name;
                }
            }
            if (rule.casualDating) {
                _this.type = "casual-dating";
            }
            else {
                _this.type = "long-term";
            }
            if (rule.withPicturesOnly) {
                _this.withPicture = "-with-picture";
            }
            if (rule.subRegionId) {
                _this.geolocationService.GetSubregion(rule.subRegionId).then(function (subreg) {
                    if (subreg) {
                        _this.city = subreg.region.shortName + "-" + subreg.name;
                    }
                });
            }
        });
    };
    HomeComponent.prototype.skipVideoPlay = function ($event) {
        this.cookieService.set("hiddenVideo", "true");
        this.showWickedVideo = false;
    };
    HomeComponent.prototype.toKebabCase = function (str) {
        return str
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    };
    HomeComponent.prototype.getCityUrl = function (city) {
        return this.toKebabCase("/" + city.region.shortName + "-" + city.name + "-" + this.type);
    };
    HomeComponent.prototype.goToCategoryUrl = function (e, category, casualDating) {
        var _this = this;
        e.preventdefault;
        var goToUrl = function (locationUrl) {
            if (locationUrl === void 0) { locationUrl = ""; }
            var url = "";
            if (casualDating) {
                url = _this.toKebabCase("/" + locationUrl + "casual-dating-" + category.name);
            }
            else {
                url = _this.toKebabCase("/" + locationUrl + "long-term-" + category.name);
            }
            _this.service.route.navigate([url]);
        };
        var locationUrl = "";
        var selectedRegionId = this.service.selectedSearchParams.region;
        var selectedSubregionId = this.service.selectedSearchParams.subregion;
        if (selectedRegionId && selectedSubregionId) {
            this.service.advService.getRegionsOnlyPromise().then(function (regions) {
                var selectedRegion = regions.find(function (r) { return r.regionId == selectedRegionId; });
                locationUrl += selectedRegion.shortName + "-";
                var subregions = _this.service.advService.getSubRegionsByRegionId(selectedRegionId);
                var selectedSubregion = subregions.find(function (r) { return r.subRegionId == selectedSubregionId; });
                locationUrl += selectedSubregion.name + "-";
            }).then(function (r) {
                goToUrl(locationUrl);
            }).catch(function (error) {
                console.log(error);
            });
            ;
        }
        else {
            goToUrl();
        }
    };
    HomeComponent.prototype.getCategoryUrl = function (category, casualDating) {
        if (casualDating) {
            return this.toKebabCase("/casual-dating-" + category.name);
        }
        else {
            return this.toKebabCase("/long-term-" + category.name);
        }
    };
    return HomeComponent;
}());
exports.HomeComponent = HomeComponent;
